import AppDispatcher from '../dispatcher/app-dispatcher'
import AppConstants from '../constants/app-constants'
import EditorConstants from '../constants/editor-constants'
import OpeOrderItem from '../objects/opeorderitem'

const EventEmitter = require('events')
const CHANGE_EVENT = 'change';

class OrderStore  {

    constructor(appDispatcher, eventEmitter) {
        // This array should contain references to the products in the order
        this._items = [];

        // What items are currently in the batch
        this._batchItems = [];

        this.batchFilterSelected = null;

        this.transationActive = false;

        //After showing the user crop and low res warnings once, we don't usually need to show them again
        this._cropAndLowResWarningsSeen = false;

        this.dispatcherIndex = appDispatcher.register(this._register.bind(this))

        this.eventEmitter = eventEmitter
    }

    startTransaction () {
        this.transationActive = true;
    }
    stopTransaction () {
        this.transationActive = false;
        this.eventEmitter.emit(CHANGE_EVENT);
    }
    emitChange () {
        var self = this;

        //console.log("Items changed", this._items);
        if (!this.transationActive) {
            this.eventEmitter.emit(CHANGE_EVENT);
        }
    }

    addChangeListener (callback) {
        this.eventEmitter.addListener(CHANGE_EVENT, callback);
    }

    removeChangeListener (callback) {
        this.eventEmitter.removeListener(CHANGE_EVENT, callback);
    }
    getCropLowresWarningSeen () {
        return this._cropAndLowResWarningsSeen;
    }
    getItems (reverse) {
        return this._items;
    }
    getItemById (id) {
        for (var i = 0; i < this._items.length; i++) {
            if (this._items[i].getId() === id) {
                return this._items[i];
            }
        }
        return null;
    }
    getFirstItemByImageId (imageId) {
        for (var i = 0; i < this._items.length; i++) {
            if (this._items[i] instanceof OpeOrderItem) {
                if (this._items[i].getImageId() === imageId) {
                    return this._items[i];
                }
            }
        }
    }
    getItemCountByImageId (imageId) {
        var count = 0;
        for (var i = 0; i < this._items.length; i++) {
            if (this._items[i].getImageId() === imageId) {
                count++;
            }
        }
        return count;
    }
    getBatchItems () {
        return this._batchItems;
    }
    getSelectedBatchFilter () {
        return this.batchFilterSelected;
    }
    allBatchItemsSelected () {
        return this._batchItems.length === this._items.length;
    }

    /**
     * Method for sorting items by image taken date
     */
    sortItemsByImageTakenDate () {
        this._items.sort(function (a, b) {
            if (a.getImageTakenDate() === b.getImageTakenDate()) {
                return 0;
            }
            if (a.getImageTakenDate() === null && b.getImageTakenDate() !== null) {
                return -1;
            }
            if (a.getImageTakenDate() !== null && b.getImageTakenDate() === null) {
                return 1;
            }
            if (a.getImageTakenDate() < b.getImageTakenDate()) {
                return -1;
            }
            return 1;
        });
    }

    /**
     * Method adds a product to the OrderStore's this._items array.
     * This method will be triggered by dispatched actions from the image selector
     * @param {OpeOrderItem} item -
     * @param {number=} atIndex - If an order item is to be added at a specific index in the array.
     *                             This is used when duplicating an order item.
     */
    _addItem(item, atIndex) {
        if (typeof atIndex !== "undefined") {
            this._items.splice(atIndex + 1, 0, item);
        }
        else {
            this._items.push(item);
        }
    }

    /**
     * This function removes a product from the orderStore
     * This can be triggered by an action dispatch from the image selector or image editor
     * @param {string|OpeOrderItem} item - the id of the product to be removed
     */
    _removeItem(item) {
        if (typeof item === "string") {
            for (var i = 0; i < this._items.length; i++) {
                if (this._items[i].getId() === item) {
                    this._items.splice(i, 1);
                    break;
                }
            }
        } else {
            var id = item.getId();
            for (var i = 0; i < this._items.length; i++) {
                if (this._items[i].getId() === id) {
                    this._items.splice(i, 1);
                    break;
                }
            }
        }
    }

    /**
     * Remove items that has the given image id
     * @param  {string} imageId
     */
    _removeItemsByImageId(imageId) {
        var i = this._items.length;
        while (i--) {
            if (this._items[i].getImageId() === imageId) {
                this._items.splice(i, 1);
            }
        }
    }

    /**
     * We log upload status for local images
     * on the order item to track bugs
     * @param {string} imageId [description]
     * @param {string} status  [description]
     */
    _setUploadStatus(imageId, status) {
        for (var i = 0; i < this._items.length; i++) {
            if (this._items[i].getImageId() === imageId) {
                this._items[i].setLocalImageUploadStatus(status);
            }
        }
    }

    /**
     * Increase the quantity volume of a product with 1
     * @param {string} id - the id of the product
     */
    _increaseItemQuantity(id) {
        for (var i = 0; i < this._items.length; i++) {
            if (this._items[i].getId() === id) {
                this._items[i].increaseQuantity();
                break;
            }
        }
    }

    /**
     * Decrease the quantity volume of a product with 1
     * @param {string} id - the id of the product
     */
    _decreaseItemQuantity(id) {
        for (var i = 0; i < this._items.length; i++) {
            if (this._items[i].getId() === id) {
                this._items[i].decreaseQuantity();
                break;
            }
        }
    }


    /**
     * @param {string} id
     * @param {quantity} number
     */
    _setItemQuantity(id, quantity) {
        quantity = parseInt(quantity);
        // Make sure that the quantity input is a valid number
        //if(!isNaN(quantity)) {
        for (var i = 0; i < this._items.length; i++) {
            if (this._items[i].getId() === id) {
                this._items[i].setQuantity(quantity);
            }
        }
        //}
    }

    /**
     * Method for setting the quantity of all the products in an order
     * this method can be triggerd from the editor view
     * @param value number - The quantity value passed to the function
     */
    _setBatchQuantity(value) {
        for (var i = 0; i < this._batchItems.length; i++) {
            this._batchItems[i].setQuantity(value);
        }
    }

    _setItemImageFilter(itemId, filterName, value) {
        for (var i = 0; i < this._items.length; i++) {
            if (this._items[i].getId() === itemId) {
                if (filterName == 'effect.type') { //Special handling for effects since they're arrays and a bit more complex to deal with
                    this._items[i].replaceFilterEffect({type: value});
                } else {
                    this._items[i].setImageFilterValue(filterName, value);
                }

                break;
            }
        }
    }

    /**
     * Method sets the value of an OrderItem's product property. This method
     * @param {string} productId - the id of the product
     * @param {string} itemId - the id of the item who's product property will change
     */
    _setItemProduct(itemId, productId, productWidth, productHeight) {
        for (var i = 0; i < this._items.length; i++) {
            if (this._items[i].getId() === itemId) {
                this._items[i].setProductId(productId);
                this._items[i].setProductWidth(productWidth);
                this._items[i].setProductHeight(productHeight);
                this._resetItem(this._items[i], true);
                break;
            }
        }
    }

    /**
     * Toggle an option on or off an item
     * @param  {string}
     * @param  {string}
     * @param  {object}
     */
    _toggleProductOption(itemId, optionName, data) {

        for (var i = 0; i < this._items.length; i++) {
            if (this._items[i].getId() === itemId) {
                if (this._items[i].hasOptionByName(optionName)) {
                    this._items[i].setOptionByName(optionName, false);
                } else {
                    this._items[i].setOptionByName(optionName, true);
                }
                break;
            }
        }
    }


    /**
     * Method for applying a filter to all items in the order
     * @param {string} filterValue - the filter to be applied to the items
     */
    _applyFilterBatch(filterValue) {
        for (var i = 0; i < this._batchItems.length; i++) {
            this._batchItems[i].replaceFilterEffect({type: filterValue});
        }
        this.batchFilterSelected = filterValue;
    }

    /**
     * Method for applying one product to all of the order items in the order
     * @param {string}
     * @param {string}
     * @param {string}
     */
    _applyProductBatch(productId, productWidth, productHeight) {
        for (var i = 0; i < this._batchItems.length; i++) {
            this._setItemProduct(this._batchItems[i].getId(), productId, productWidth, productHeight);
        }
    }

    /**
     * Method for duplicating an order item
     * @param {String}
     */
    _duplicateOrderItem(itemId) {
        var item = this.getItemById(itemId);
        var newOptions,
            newOrderItem,
            newInformation,
            itemIndex = this._getItemIndex(item.id);


        newOptions = JSON.parse(JSON.stringify(item.options));
        newInformation = JSON.parse(JSON.stringify(item.information));
        newOrderItem = new OpeOrderItem(item.imageId, item.productId, newOptions, item.isPortrait);
        newOrderItem.setImageTakenDate(item.getImageTakenDate());
        newOrderItem.information = newInformation;
        newOrderItem.setQuantity(1);

        this._addItem(newOrderItem, itemIndex);
        this.emitChange();
    }

    /**
     * Method for getting the indexOf an OrderItem from the this._items array
     * @param {string} id - the OrderID of the item
     */
    _getItemIndex(id) {
        var index = 0;
        for (var i = 0; i < this._items.length; i++) {
            // If the item id is found, return index
            if (this._items[i].getId() === id) {
                return index;
            }
            else {
                index++;
            }
        }
    }

    /**
     * Method for resetting options on an order item. This method is called from the
     * options component of the detailed product view
     *
     * @param {OpeOrderItem} item - The order item to be reset
     * @param {boolean} dontRemoveFilterEffect
     */
    _resetItem(item, dontRemoveFilterEffect) {
        var options = item.options;
        delete options.crop;
        if (options.imageFilter && !dontRemoveFilterEffect) {
            delete options.imageFilter.effects;
        }
        if (options.imageFilter) {
            if (options.imageFilter.rotate) {
                options.imageFilter.rotate.angle = 0;
            }
        }
        options.scale = 1.0;
        item.setPercentage();

        item.optionsStored = null;
    }

    /**
     * Cancel item changes.
     *
     * @param {OpeOrderItem} item
     */
    _cancelItemChanges(item) {
        if (!item.optionsStored) {
            return;
        }

        var stored = JSON.parse(item.optionsStored);
        var options = item.options;

        // Restore data.

        options.crop = (stored.crop ? stored.crop : options.crop);

        if (options.imageFilter) {
            if (stored.imageFilter && stored.imageFilter.effects) {
                options.imageFilter.effects = stored.imageFilter.effects;
            }
            else {
                delete options.imageFilter.effects;
            }

            if (options.imageFilter.rotate) {
                if (stored.imageFilter.rotate && stored.imageFilter.rotate.angle) {
                    options.imageFilter.rotate.angle = stored.imageFilter.rotate.angle;
                }
                else {
                    options.imageFilter.rotate.angle = 0;
                }
            }
        }

        options.scale = stored.scale;

        options.position.percentageX = stored.position.percentageX;
        options.position.percentageY = stored.position.percentageY;
    }

    /**
     * Method that adds a low-res warning to an order item if the image's resolution
     * suited for the selected format size
     * @param {string} itemId
     */
    _addLowResWarning(itemId) {
        for (var i = 0; i < this._items.length; i++) {
            var item = this._items[i];
            if (item.getId() == itemId) {
                // If a low res warning is not already present add it
                item.setLowResWarning(true);
                break;
            }
        }
    }

    _setLowResWarningOverride(itemId, giveWarning) {
        for (var i = 0; i < this._items.length; i++) {
            var item = this._items[i];
            if (item.getId() == itemId) {
                // If a low res warning is not already present add it
                item.setLowResWarningOverride(giveWarning);
                break;
            }
        }
    }

    _setAutoCropWarningOverride(itemId, giveWarning) {
        for (var i = 0; i < this._items.length; i++) {
            var item = this._items[i];
            if (item.getId() == itemId) {
                // If a low res warning is not already present add it
                item.setAutoCropWarningOverride(giveWarning);
                break;
            }
        }
    }

    /**
     * Method for removing LowResWarning from given item
     * @param {string} itemId
     */
    _removeLowResWarning(itemId) {
        for (var i = 0; i < this._items.length; i++) {
            var item = this._items[i];
            if (item.getId() == itemId) {
                // If a low res warning is not already present add it
                item.setLowResWarning(false);
                break;
            }
        }
    }

    /**
     * Method that sets a auto-crop warning to an order item if the image's resolution
     * suited for the selected format size
     * @param {string} itemId
     * @param {boolean} giveWarning should customer be warned or not?
     */
    _setAutoCropWarning(itemId, giveWarning) {
        for (var i = 0; i < this._items.length; i++) {
            var item = this._items[i];
            if (item.getId() == itemId) {
                item.setAutoCropWarning(giveWarning);
                break;
            }
        }
    }

    /**
     * Method for toggling between all or no items in the this._batchItems
     * @param {boolean} batchSelected
     */
    _toggleBatchSelection(batchSelected) {
        if (batchSelected) {
            for (var i = 0; i < this._items.length; i++) {
                this._batchItems[i] = this._items[i];
            }
        }
        else {
            this._batchItems = [];
        }
    }


    /**
     * Method for toggling an item from the this._batchItems array
     * @param {OpeOrderItem} item
     * @param {boolean} inBatch
     */
    _toggleBatchItemSelection(item, inBatch) {
        if (inBatch) {
            this._batchItems.push(item);
        }
        else {
            for (var i = 0; i < this._batchItems.length; i++) {
                var batchItem = this._batchItems[i];
                if (batchItem.id == item.id) {
                    this._batchItems.splice(i, 1);
                    break;
                }
            }
        }
    }

    /**
     * Method for rotating image
     * @param {OpeOrderItem} - the item to be rotated
     * @param {number} - the angle rotation (-90 or 90 deg )
     */
    _rotateItemImage(item, angle) {

        var currentAngle;
        try {
            currentAngle = item.options.imageFilter.rotate.angle;
        } catch (e) {
            currentAngle = 0;
        }

        if (!Number.isInteger(currentAngle)) {
            currentAngle = 0;
        }

        var isPortrait = item.isPortrait;
        var nextAngle;

        nextAngle = currentAngle + angle;
        if (nextAngle > 270) {
            nextAngle = 0;
        }
        if (nextAngle < 0) {
            nextAngle = 270;
        }

        if (!item.options.imageFilter.hasOwnProperty("rotate")) {
            item.options.imageFilter.rotate = {};
        }

        item.options.imageFilter.rotate.angle = nextAngle;
        item.isPortrait = isPortrait;
        item.setPercentage();
    }

    /**
     * Method for updating the crop position (in percentage) of an order item
     * @param {OpeOrderItem} - item
     * @param {number} - x
     * @param {number} - y
     */
    _setCropPercentagePositionScale(item, scale, x, y) {
        item.options.position.percentageX = x;
        item.options.position.percentageY = y;
        item.options.scale = scale;
    }

    /**
     * Method for saving the scale of an order item
     * @param {OpeOrderItem} item
     * @param {number} scale
     */
    _setCropScale(item, scale) {
        item.options.scale = scale;
    }

    _setImageTakenDate(itemId, date) {
        for (var i = 0; i < this._items.length; i++) {
            var item = this._items[i];
            if (item.getId() == itemId) {
                item.setImageTakenDate(date);
            }
        }
    }

    /**
     * Method for setting the label of an order item
     * @param {item}
     * @param {label}
     */
    _setItemPolaroidText(item, label) {
        item.options.polaroidText = label;
    }

    /**
     * This is used to control the popup that displays warnings about
     * crop and lowres. We don't want to pop it too many times, so we need to
     * store a boolean if we have shown it or not. But sometimes things change, like
     * users adding more images, and then we might need to show it again. Thus we have
     * this variable in the store to toggle it.
     * @param {[type]} seen [description]
     */
    _setCropAndLowResWarningsSeen(seen) {
        this._cropAndLowResWarningsSeen = seen;
    }

    _register(payload) {

        var action = payload.action;
        switch (action.actionType) {
            case AppConstants.ADD_ITEM:
                this._addItem(action.item);
                this.emitChange();
                break;
            case AppConstants.ADD_ITEMS:
                for (var i = 0; i < action.items.length; i++) {
                    this._addItem(action.items[i]);
                }
                this.emitChange();
                break;
            case AppConstants.REMOVE_ITEM:
                this._removeItem(action.item);
                this.emitChange();
                break;
            case AppConstants.DUPLICATE_ITEM:
                this._duplicateOrderItem(action.itemId);
                break;
            case AppConstants.INCREASE_ITEM_QUANTITY:
                this._increaseItemQuantity(action.id);
                this.emitChange();
                break;
            case AppConstants.DECREASE_ITEM_QUANTITY:
                this._decreaseItemQuantity(action.id);
                this.emitChange();
                break;
            case AppConstants.SET_ITEM_QUANTITY:
                this._setItemQuantity(action.itemId, action.quantity);
                this.emitChange();
                break;
            case AppConstants.SET_ORDER_ITEM_PRODUCT:
                this._setItemProduct(action.itemId, action.productId, action.productWidth, action.productHeight);
                this.emitChange();
                break;
            case EditorConstants.SET_BATCH_QUANTITY:
                this._setBatchQuantity(action.value);
                this.emitChange();
                break;
            case EditorConstants.TOGGLE_PRODUCT_OPTION:
                this._toggleProductOption(action.itemId, action.optionName, action.data);
                this.emitChange();
                break;
            case AppConstants.SET_ITEM_IMAGE_FILTER:
                this._setItemImageFilter(action.itemId, action.filterName, action.value);
                this.emitChange();
                break;
            case EditorConstants.APPLY_FILTER_TO_BATCH:
                this._applyFilterBatch(action.filterValue);
                this.emitChange();
                break;
            case EditorConstants.SET_PRODUCT_BATCH:
                this._applyProductBatch(action.productId, action.productWidth, action.productHeight);
                this.emitChange();
                break;
            case AppConstants.RESET_ITEM_OPTIONS:
                this._resetItem(action.item);
                this.emitChange();
                break;
            case AppConstants.CANCEL_ITEM_CHANGES:
                this._cancelItemChanges(action.item);
                this.emitChange();
                break;
            case AppConstants.SET_LOW_RES_WARNING:
                this._addLowResWarning(action.itemId);
                this.emitChange();
                break;
            case AppConstants.REMOVE_LOW_RES_WARNING:
                this._removeLowResWarning(action.itemId);
                this.emitChange();
                break;
            case AppConstants.SET_AUTO_CROP_WARNING:
                this._setAutoCropWarning(action.itemId, action.giveWarning);
                this.emitChange();
                break;
            case AppConstants.TOGGLE_BATCH_SELECTION:
                this._toggleBatchSelection(action.batchSelected);
                this.emitChange();
                break;
            case AppConstants.TOGGLE_ITEM_BATCH_STATE:
                this._toggleBatchItemSelection(action.item, action.inBatch);
                this.emitChange();
                break;
            case AppConstants.ROTATE_IMAGE:
                this._rotateItemImage(action.item, action.angle);
                this.emitChange();
                break;
            case AppConstants.SET_CROP_POSITION_SCALE:
                this._setCropPercentagePositionScale(action.item, action.scale, action.x, action.y);
                this.emitChange();
                break;
            case AppConstants.SET_CROP_SCALE:
                this._setCropScale(action.item, action.scale);
                this.emitChange();
                break;
            case AppConstants.SET_ITEM_IMAGE_TAKEN_DATE:
                this._setImageTakenDate(action.item, action.date);
                this.emitChange();
                break;
            case AppConstants.SET_LOW_RES_WARNING_OVERRIDE:
                this._setLowResWarningOverride(action.itemId, action.giveWarning);
                this.emitChange();
                break;
            case AppConstants.SET_AUTO_CROP_WARNING_OVERRIDE:
                this._setAutoCropWarningOverride(action.itemId, action.giveWarning);
                this.emitChange();
                break;
            case AppConstants.REMOVE_ITEMS_BY_IMAGEID:
                this._removeItemsByImageId(action.imageId);
                this.emitChange();
                break;
            case AppConstants.ADD_ITEM_LABEL:
                this._setItemLabel(action.item, action.label);
                this.emitChange();
                break;
            case AppConstants.SET_ORDER_ITEM_UPLOAD_STATUS:
                this._setUploadStatus(action.imageId, action.status);
                //No need to emit change
                break;
            case AppConstants.SET_CROP_LOWRES_WARNING_SEEN:
                this._setCropAndLowResWarningsSeen(action.seen);
                this.emitChange();
                break;


        }
        return true;
    
    }
}

const store = new OrderStore(AppDispatcher, new EventEmitter())


export default store;
export {OrderStore as OrderStoreClass};
